module.exports = __webpack_public_path__ + "./docs/img/voice.fb13d4e183a8c608995592b7ae09d11f.svg";